import { compose, lifecycle, setPropTypes, withState } from 'recompose';
import PropTypes from 'prop-types';

let isMounted = false;

const propTypes = {
  altText: PropTypes.string,
  className: PropTypes.string,
  imgUrl: PropTypes.string,
};

function componentDidMount() {
  isMounted = true;
  const { imgUrl, setImageIsValid } = this.props;

  const img = new Image();
  img.onload = () => isMounted && setImageIsValid(true);
  img.onerror = () => isMounted && setImageIsValid(false);
  img.src = imgUrl;
}

function componentWillUnmount() {
  isMounted = false;
}

export default compose(
  setPropTypes(propTypes),
  withState('imageIsValid', 'setImageIsValid', false),
  lifecycle({ componentDidMount, componentWillUnmount }),
);
